import { Navigate } from "react-router"

const RootPage = () => {
  // redirect to /ruido-dosis
  return (
    <Navigate to="/ruido-dosis" />
  )
}

export default RootPage